import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrepagoConceptoRequest } from 'src/app/modal/niubiz/prepago-concepto-request';
import { NiubizService } from 'src/app/service/niubiz/niubiz.service';
import { PagoConceptoRequest } from 'src/app/modal/niubiz/pago-concepto-request';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { CarritoService } from 'src/app/service/carrito/carrito.service';

@Component({
  selector: 'app-resul-pago-niubiz',
  templateUrl: './resul-pago-niubiz.component.html',
  styleUrls: ['./resul-pago-niubiz.component.scss']
})
export class ResulPagoNiubizComponent implements OnInit {


  loadFinPago = false;
  loadingPago = false;
  loadingError= false;
  dataPago: any;
  pagoConceptoRequest:PagoConceptoRequest;

  mensaje ="";


  mensajeError = '';
  dataPopPago: any;
  
  constructor(
    private route: ActivatedRoute,
    private router:Router,
    private utilitarioService:UtilitarioService,
    private niubizService: NiubizService,
    private carritoService:CarritoService
  ) { 
  }

  ngOnInit(): void {
    this.dataPopPago = JSON.parse(localStorage.getItem("dataPopPago"));
  }

  ngAfterViewInit(): void {
    this.route.params.subscribe(params => {
        this.registrarPago(params.transactionToken,params.amount,params.purchasenumber);
      /*},(error) => {*/
    });
  }

  registrarPago(transactionToken,amount,purchasenumber) {
    //this.dataTab.emit(0);
    this.loadFinPago = false;
    this.loadingError= false;
    this.utilitarioService.loading=true;
    this.pagoConceptoRequest = new PagoConceptoRequest();
    this.pagoConceptoRequest.transactionToken=transactionToken;
    this.pagoConceptoRequest.amount=amount;
    this.pagoConceptoRequest.purchasenumber=purchasenumber;

    // Obtener la moneda guardada en localStorage durante el prepago
    const savedCurrency = localStorage.getItem('niubiz_currency') || 'PEN';
    this.pagoConceptoRequest.currency = savedCurrency;
    this.pagoConceptoRequest.hcurrency = savedCurrency;
    // console.log('💰 [RESULTADO-PAGO] Moneda recuperada:', savedCurrency);

    this.niubizService.registrarPagoConceptoPago(this.pagoConceptoRequest).subscribe(response =>{
    
        // console.log(response);
     // aqui muestras lo que te retorna el servicio
        if(response.resultado=='0'){
          this.mensaje = response.mensaje;
          this.utilitarioService.toastrSuccess(response.mensaje);
          this.utilitarioService.loading=false;
          this.carritoService.limpiarCarrito();
          this.router.navigate(['/mi-cuenta/mis-pedidos'])
        }
        else{
          this.utilitarioService.toastrWarning("La transacción fue rechazada. Intente nuevamente o use otro medio de pago.");
          this.router.navigate(['/procesarpago'])
        }
       
      }
   
    ,(error) => {
      // console.log(error);
      this.utilitarioService.toastrError("La transacción fue rechazada. Intente nuevamente o use otro medio de pago.");
      this.utilitarioService.loading=false;

      this.router.navigate(['/procesarpago'])
    }
    );
  }
}
